export default __webpack_public_path__ + "static/media/fetured-item-5.a8829ed3.png";